export enum CookieType {
	Location,
	Language,
	Market,
	PreferredOrganization,
	PreferredLocation,
}
